import FD from '../../../RestAPI/fetchData';
import config from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';

const fetchQuestionsChapterWise = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/question-bank/all-questions`, data);
};
const fetchChapterNameById = async (data) => {
  return await FD.callAPI(`${config.backend_api}/esg/chapter-by-id`, data);
};
const pdfDownloadViaEmail = async (data) => {
  return await FD.callAPI(`${config.backend_api}/esg/question/pdf-download-via-email`, data);
};
module.exports = {
  fetchQuestionsChapterWise,
  fetchChapterNameById,
  pdfDownloadViaEmail,
};



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/QuestionsViewList/ApiService.js